import { BrowserRouter as Router, Route, Routes, useSearchParams } from "react-router-dom";
import { LandingPage } from "./landing_page.js";
import { ResumePage } from "./components/resume_page.js";
import BootupScreen from './components/bootup_screen.js';

function AppContent() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  let bootToggle = false;
  if (type === "full") {
    bootToggle = true;
  }
  return (
    <BootupScreen toggle={bootToggle}>
      <div className="black-border">
        <div className="crt-bloom">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/resume" element={<ResumePage />} />
          </Routes>
        </div>
      </div>
    </BootupScreen>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
